import React from 'react'
import CommonNavbar from '../../components/CommonNavbar/CommonNavbar'
import CommonFooter from '../../components/CommonFooter/CommonFooter'
const AgriOutputEMarketplace = () => {
  return (
    <>
      <CommonNavbar />

      <div className='py-5'>
        <div className='container px-md-5'>
          <div className='p-8 bg-white'>
            <div className='max-w-5xl mx-auto'>
              {/* Header */}
              <h2 className='text-3xl font-bold text-gray-800 mb-4 clr_dark_green'>
                Farmer’s City Agri Output Store
              </h2>
              <p className='text-gray-600 mb-8'>
                The Farmer’s City (FC) Agri Output Store is a pivotal component
                of our integrated platform, designed to facilitate the sale and
                purchase of agricultural produce, livestock, and other
                output-related services. These stores serve as hubs for farmers
                to market their products, connect with buyers, and access
                essential post-harvest linkages. Our goal is to streamline the
                agricultural value chain by providing a seamless blend of
                physical and digital services tailored to the needs of
                smallholder farmers.
              </p>

              {/* Services Offered */}
              <h3 className='text-2xl font-semibold text-gray-800 mb-4 clr_dark_green'>
                Services Offered at FC Agri Output Store
              </h3>
              <ul className='list-disc pl-6 text-gray-700 mb-8 space-y-2'>
                <li>
                  <strong>Agri-Output Marketplace:</strong> Collaborate with
                  buyers, food processors, retailers, and other stakeholders to
                  facilitate the sale and purchase of agricultural produce.
                </li>
                <li>
                  <strong>Livestock Sale/Purchase:</strong> Connect farmers with
                  livestock dealers for buying or selling livestock, ensuring
                  fair and transparent transactions.
                </li>
                <li>
                  <strong>Agricultural Land Services:</strong> Provide
                  information on agricultural land availability, lease options,
                  and facilitate land transactions for farming purposes.
                </li>
                <li>
                  <strong>Contract Farming:</strong> Support farmers in engaging
                  in contract farming agreements with reliable partners for
                  mutual benefit.
                </li>
                <li>
                  <strong>Post-Harvest Linkages:</strong> Assist farmers in
                  accessing services related to storage, processing, packaging,
                  and transportation of agricultural produce.
                </li>
              </ul>

              {/* How to Engage */}
              <h3 className='text-2xl font-semibold text-gray-800 mb-4 clr_dark_green'>
                How to Engage with FC Agri Output Store
              </h3>
              <ul className='list-disc pl-6 text-gray-700 mb-8 space-y-2'>
                <li>
                  <strong>Visit the Nearest Store:</strong> Locate your nearest
                  FC Agri Output Store either through our mobile app or website.
                </li>
                <li>
                  <strong>Explore Market Opportunities:</strong> Browse through
                  available listings for agricultural produce, livestock, and
                  other output-related services.
                </li>
                <li>
                  <strong>Connect with Buyers/Sellers:</strong> Engage with
                  potential buyers or sellers to negotiate deals and
                  transactions.
                </li>
                <li>
                  <strong>Avail Additional Services:</strong> Take advantage of
                  ancillary services such as quality assessment, certification,
                  and logistics support offered at the store.
                </li>
              </ul>

              {/* Franchise Opportunities */}
              <h3 className='text-2xl font-semibold text-gray-800 mb-4 clr_dark_green'>
                Franchise Opportunities
              </h3>
              <p className='text-gray-600 mb-6'>
                If you are interested in becoming a part of the Farmer’s City
                network and owning an FC Agri Output Store franchise, we offer a
                comprehensive support system that includes:
              </p>
              <ul className='list-disc pl-6 text-gray-700 mb-8 space-y-2'>
                <li>Initial investment guidance</li>
                <li>Training programs for store management</li>
                <li>Marketing and promotional assistance</li>
                <li>
                  Access to a wide network of buyers, sellers, and service
                  providers
                </li>
              </ul>

              {/* Closing */}
              <p className='text-gray-700 font-medium'>
                Join us in revolutionizing the agri-output industry and
                empowering farmers across the country through our innovative
                phygital model that combines the best of physical stores and
                digital platforms.
              </p>

              <p className='mt-4 text-blue-600 underline'>
                For more information, visit{' '}
                <a
                  href='https://www.farmerscity.co.in/agrioutputstore'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  www.farmerscity.co.in/agrioutputstore
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <CommonFooter />
    </>
  )
}

export default AgriOutputEMarketplace
